import { SUPPORT_PHONE, SUPPORT_PHONE_TEL } from '../constants/site';

export default function FixedCallBar() {
  return (
    <div className="t7-callbar" role="region" aria-label="Call support">
      <a href={`tel:${SUPPORT_PHONE_TEL}`}>
        Call Us : {SUPPORT_PHONE}
      </a>
    </div>
  );
}
